import type { FieldProps } from 'formik';
import { Label } from '@savvy-kit/components/label';
import SearchableCombobox from '@savvy-kit/patterns/searchable-combobox';
import { Field } from 'formik';

type Props<N extends string> = {
  readonly label: string;
  readonly name: N;
  readonly options: string[];
};

export function FormikSearchableCombobox<N extends string>({ label, name, options }: Props<N>) {
  return (
    <Field name={name}>
      {({ form, meta }: FieldProps) => (
        <div>
          {/* No htmlFor: cmdk spreads its own id and aria-labelledby onto the input last,
              so neither this Label nor the kit's `id` prop can reach it. */}
          <Label className="pb-2">{label}</Label>
          <SearchableCombobox
            label={label}
            options={options.map((option) => ({ value: option, label: option }))}
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            value={String(form.values[name] ?? '')}
            onValueChange={(option) => {
              void form.setFieldValue(name, option);
            }}
            // Not form.handleBlur — it resolves the field from event.target.name ?? .id,
            // and cmdk's input has no name and its own generated id.
            onInputBlur={() => {
              void form.setFieldTouched(name, true);
            }}
            error={meta.touched && !!meta.error}
            errorMessage={meta.error}
          />
        </div>
      )}
    </Field>
  );
}
